import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

interface EditButtonProps {
    isEditing: boolean;
    onClick: () => void;
    disabled?: boolean;
}

/**
 * A reusable edit button component for the dashboard
 *
 * @param {EditButtonProps} props - The component props
 * @returns {JSX.Element} The edit button component
 */
export const EditButton: React.FC<EditButtonProps> = ({ isEditing, onClick, disabled }) => {
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).dashboard;

    return (
        <Button variant="contained" startIcon={<EditIcon />} onClick={onClick} disabled={disabled}>
            {isEditing ? langStrings.oftenUsed.save : langStrings.oftenUsed.edit}
        </Button>
    );
};

export default EditButton;
